(() => {
  if (typeof JotformFeedback !== 'function') return;
  window.JFL_261855882964071 = new JotformFeedback({
    formId: '261855882964071',
    base: 'https://form.jotform.com/',
    windowTitle: 'Widerrufsformular',
    backgroundColor: '#0071e3',
    fontColor: '#ffffff',
    type: 'false',
    height: 650,
    width: 760,
    openOnLoad: false
  });
})();
